import * as React from 'react'

import type { FeaturedItemsCardViewModel } from '../../view-models/FeaturedItemsCardViewModel'
import { ContentCard } from '@/components/ContentCard/ContentCard'

function FeaturedItemCard(props: FeaturedItemsCardViewModel) {
  return <ContentCard {...props} />
}

FeaturedItemCard.displayName = 'FeaturedItemCard'
FeaturedItemCard.defaultProps = {}

export default FeaturedItemCard
